import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { ProductTabComponent } from '@b2b/components/product/product-tab/product-tab.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'product-specifications',
  imports: [CommonModule, AccordionComponent, TranslateModule],
  templateUrl: './product-specifications.component.html',
  styleUrl: './product-specifications.component.scss',
})
export class ProductSpecificationsComponent extends ProductTabComponent {}
